module.exports = __webpack_public_path__ + "assets/098b781b3712c35fceaf8c2383466ed2.mp3";